
import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import AppRoutes from "@/components/AppRoutes";
import { useWebsiteVisitTracking } from "@/hooks/useWebsiteVisitTracking";
import ScrollToTopRouter from "@/components/ScrollToTopRouter";
import GoogleAnalyticsScript from "@/components/analytics/GoogleAnalyticsScript";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
    },
  },
});

// Website tracking wrapper component
const AppWithTracking: React.FC = () => {
  useWebsiteVisitTracking();
  
  return (
    <>
      <GoogleAnalyticsScript />
      <AppRoutes />
      <Toaster />
      <Sonner />
    </>
  );
};

// Simplified App component
const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <LanguageProvider>
            <BrowserRouter>
              <ScrollToTopRouter />
              <AppWithTracking />
            </BrowserRouter>
          </LanguageProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
